import type { Stat } from '../types/content';
import { IMAGES } from './images';

export const trustChips = [
  'Sheriff-Approved Since 2010',
  'NRA Training Counselor',
  'USCCA Certified',
  '14,000+ Students Trained',
  'Women-Only Classes Available',
];

export const quickStartTiles = [
  { id: 'ccw', title: 'Get My CCW Permit', tag: '8-hr', duration: '8 hours', price: 150, image: IMAGES.classroom, to: '/courses/multi-state-ccw', popular: true },
  { id: 'renew', title: 'Renew My CCW', tag: '4-hr', duration: '4 hours', price: 85, image: IMAGES.students, to: '/courses/nv-ccw-renewal', popular: false },
  { id: 'new', title: "I'm Brand New to Handguns", tag: 'ITDH', duration: '4 hours', price: 150, image: IMAGES.grip, to: '/courses/itdh', popular: false },
  { id: 'women', title: "Women's Classes", tag: 'Women-only', duration: '4–8 hours', price: 150, image: IMAGES.women, to: '/womens-training', popular: false },
];

export const whyPoints = [
  { title: 'Defense-focused, not range-day fun', body: 'Every drill exists because it applies to a real defensive encounter.' },
  { title: 'Nevada law in plain English', body: 'Use of force and criminal and civil liability, explained clearly by people who teach it every week.' },
  { title: 'Small classes, real coaching', body: 'Instructors watch you shoot and correct you on the spot — not from across the range.' },
  { title: 'A clear path, beginner to advanced', body: 'A recommended sequence means you always know what to train next.' },
];

/** Placeholder figures — update with current numbers. */
export const stats: Stat[] = [
  { value: 14000, suffix: '+', label: 'Students trained' },
  { value: 15, suffix: '+', label: 'Years teaching' },
  { value: 50, prefix: '~', label: 'Classes a week' },
  { value: 7, label: 'Days a week training' },
  { value: 12, label: 'Vetted instructors' },
];

export const trainingPath = [
  { code: 'ITDH', name: 'Introduction to Defensive Handgun', slug: 'itdh' },
  { code: 'CCW', name: 'Multi-State CCW', slug: 'multi-state-ccw' },
  { code: 'FOHD', name: 'Fundamentals of Home Defense', slug: 'fohd' },
  { code: 'FOCC', name: 'Fundamentals of Concealed Carry', slug: 'focc' },
  { code: 'IDS', name: 'Intuitive Defensive Shooting (1 or 2 day)', slug: 'ids' },
  { code: 'DDC', name: 'Dynamic Defensive Carbine', slug: 'ddc' },
  { code: 'LLDH', name: 'Low Light Defensive Handgun', slug: 'low-light' },
  { code: 'DDH', name: 'Dynamic Defensive Handgun', slug: 'ddh' },
];

export const ccwSteps = [
  { title: 'Take the sheriff-approved course', body: '8-hour initial course. Renewing? The 4-hour renewal course.' },
  { title: 'Pass the test and qualification', body: 'A written exam and live-fire qualification, with instructors coaching you through.' },
  { title: 'Apply with your county sheriff', body: 'Residents apply in their county. Non-residents can apply with any Nevada county sheriff.' },
  { title: 'Carry legally and keep training', body: 'Your permit is the start. Ongoing training is what keeps you ready.' },
];
